define(function (require, exports, module) {
    var classifier = require('es6ish-class/es6ish-class');

    var parse = JSON.parse;
    var stringify = JSON.stringify;
    var isArray = Array.isArray;
    var STRING = 'string';

    function copy (source, target) {
        target = target || {};
        var item;
        for (item in source) {
            if (source.hasOwnProperty(item)) {
                target[item] = source[item];
            }
        }
        return target;
    }

    function PatchableApiModel (data) {
        if (isArray(data)) {
            this.isPatch = true;
            this.diffs = data;
            return this;
        }
        var dataString = this.dataString = typeof data === STRING ? data : stringify(data || {});

        this.originalData = data;
        copy(parse(dataString), this);
        this.parseData();
    }

    PatchableApiModel.prototype = {
        isPatch: false,
        diffs: null,
        /**
         * Create a full copy of api response
         * @return {object} Clean clone of the current GumboModel instance
         */
        clone: function () {
            return new this.constructor(this.dataString);
        },

        create: function (data) {
            return new this.constructor(data);
        },

        parseData: function () {
            return this;
        }
    };

    return classifier(PatchableApiModel);
});
